import { Button, HorizontalSpacer, Label, Layout, Panel, Step, Stepper, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutArchiveVoidedCommissions extends Layout {
    buttonArchive: Button;
    horizontalspacer1: HorizontalSpacer;
    labelArchiveTitle: Label;
    panelView: Panel;
    stepArchive: Step;
    stepEditList: Step;
    stepParameters: Step;
    stepperArchiveVoidedCommissions: Stepper;
    textboxCutoffDate: Textbox;
    textboxPayee: Textbox;
}
